// import PrestationsPage from "../../pages/prestations/PrestationsPage";
import PrestaIcon from "@mui/icons-material/SaveAlt";

export const PrestationsRoutes = [
    // ############# Prestations ###############

    {
        name : "prestations",
        title : "Prestations",
        path : "/ui/prestations",
        component : null,
        // component : PrestationsPage,
        icon: <PrestaIcon/>,
        private : true,
        showMenu: false,
        roles: [
            'ROLE_INSURED',
        ]
    },
]
